window.trisara = window.trisara || {};

trisara.config = {
  bpSmall: false,
  mediaQuerySmall: "screen and (max-width: " + 900 + "px)",
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
};

trisara.config.bpSmall = matchMedia(trisara.config.mediaQuerySmall).matches;
matchMedia(trisara.config.mediaQuerySmall).addListener(function (mql) {
  if (mql.matches) {
    trisara.config.bpSmall = true;
    document.dispatchEvent(new CustomEvent("matchSmall"));
  } else {
    trisara.config.bpSmall = false;
    document.dispatchEvent(new CustomEvent("unmatchSmall"));
  }
});
trisara.utils = {
  defaultTo: function (value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  wrap: function (el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce: function (wait, callback, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },
  throttle: function (limit, callback) {
    var waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function () {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition: function (el, callback) {
    el.addEventListener("transitionend", removeClass);

    function removeClass(evt) {
      el.classList.remove("is-transitioning");
      el.removeEventListener("transitionend", removeClass);
    }

    el.classList.add("is-transitioning");
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === "function") {
      callback();
    }
  },

  compact: function (array) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize: function (form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (
        !field.name ||
        field.disabled ||
        ["file", "reset", "submit", "button"].indexOf(field.type) > -1
      )
        return;
      if (field.type === "select-multiple") {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
      );
    });
    return arr.join("&");
  },
};
trisara.delegate = {
  on: function (event, callback, options) {
    if (!this.namespaces)
      // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split(".")[0], callback, options);
    return this;
  },
  off: function (event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split(".")[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = trisara.delegate.on;
window.off = Element.prototype.off = trisara.delegate.off;

trisara.a11y = {
  trapFocus: function (options) {
    var eventsName = {
      focusin: options.namespace ? "focusin." + options.namespace : "focusin",
      focusout: options.namespace
        ? "focusout." + options.namespace
        : "focusout",
      keydown: options.namespace
        ? "keydown." + options.namespace
        : "keydown.handleFocus",
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
    );
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter((el) => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute("tabindex", "-1");
    options.elementToFocus.focus();

    document.documentElement.off("focusin");
    document.documentElement.on(eventsName.focusout, function () {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function (evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.container) {
      options.container.removeAttribute("tabindex");
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function (namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add("lock-scroll");
    el.on("touchmove" + namespace, function () {
      return true;
    });
  },

  unlockMobileScrolling: function (namespace, element) {
    document.documentElement.classList.remove("lock-scroll");
    var el = element ? element : document.documentElement;
    el.off("touchmove" + namespace);
  },
};

trisara.Modals = (function () {
  function Modal(id, name, options) {
    var defaults = {
      close: ".js-modal-close",
      open: ".js-modal-open-" + name,
      openClass: "modal--is-active",
      closingClass: "modal--is-closing",
      bodyOpenClass: ["modal-open"],
      bodyOpenSolidClass: "modal-open--solid",
      bodyClosingClass: "modal-closing",
      closeOffContentClick: true,
    };

    this.id = id;
    this.modal = document.getElementById(id);

    if (!this.modal) {
      return false;
    }

    this.modalContent = this.modal.querySelector(".modal__inner");

    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusIdOnOpen
      ? document.getElementById(this.config.focusIdOnOpen)
      : this.modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function () {
    document.querySelectorAll(this.config.open).forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", this.open.bind(this));
    });

    this.modal.querySelectorAll(this.config.close).forEach((btn) => {
      btn.addEventListener("click", this.close.bind(this));
    });

    // Close modal if a drawer is opened
    document.addEventListener(
      "drawerOpen",
      function () {
        this.close();
      }.bind(this)
    );
  };

  Modal.prototype.open = function (evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget.setAttribute(
        "aria-expanded",
        "true"
      );
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.modal.classList.add(this.config.openClass);

    document.documentElement.classList.add(...this.config.bodyOpenClass);

    if (this.isSolid) {
      document.documentElement.classList.add(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    trisara.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen,
      namespace: "modal_focus",
    });

    let openModal = new CustomEvent("modalOpen", { detail: this });

    document.dispatchEvent(openModal);
    document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

    this.bindEvents();
  };

  Modal.prototype.close = function (evt) {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Do not close modal if click happens inside modal content
    if (evt) {
      if (evt.target.closest(".js-modal-close")) {
        // Do not close if using the modal close button
      } else if (evt.target.closest(".modal__inner")) {
        return;
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);
    this.modal.classList.add(this.config.closingClass);

    document.documentElement.classList.remove(...this.config.bodyOpenClass);
    document.documentElement.classList.add(this.config.bodyClosingClass);

    window.setTimeout(
      function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (
          this.activeSource &&
          this.activeSource.getAttribute("aria-expanded")
        ) {
          this.activeSource.setAttribute("aria-expanded", "false").focus();
        }
      }.bind(this),
      500
    ); // modal close css transition

    if (this.isSolid) {
      document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    trisara.a11y.removeTrapFocus({
      container: this.modal,
      namespace: "modal_focus",
    });
    

    document.dispatchEvent(new CustomEvent("modalClose." + this.id));

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    window.on(
      "keyup.modal",
      function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this)
    );

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.modal.on("click.modal", this.close.bind(this));
    }
  };

  Modal.prototype.unbindEvents = function () {
    document.documentElement.off(".modal");

    if (this.config.closeOffContentClick) {
      this.modal.off(".modal");
    }
  };

  return Modal;
})();

trisara.Drawers = (function () {
  function Drawers(id, name) {
    this.config = {
      id: id,
      close: ".js-drawer-close",
      open: ".js-drawer-open-" + name,
      openClass: "js-drawer-open",
      closingClass: "js-drawer-closing",
      activeDrawer: "drawer--is-open",
      namespace: ".drawer-" + name,
    };

    this.nodes = {
      page: document.querySelector("#MainContent"),
    };

    this.drawer = document.querySelector("#" + id);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = Object.assign({}, Drawers.prototype, {
    init: function () {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach((openBtn) => {
        openBtn.setAttribute("aria-expanded", "false");
        openBtn.addEventListener("click", this.open.bind(this));
      });

      this.drawer
        .querySelector(this.config.close)
        .addEventListener("click", this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener(
        "modalOpen",
        function () {
          this.close();
        }.bind(this)
      );
    },

    open: function (evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        evt.currentTarget.setAttribute("aria-expanded", "true");
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute("aria-expanded", "true");
        this.activeSource = returnFocusEl;
      }

      trisara.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.add(this.config.openClass);
      this.isOpen = true;

      trisara.a11y.trapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      document.dispatchEvent(new CustomEvent("drawerOpen"));
      document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id));

      this.bindEvents();
    },

    close: function (evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest(".js-drawer-close")) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest(".drawer")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      trisara.utils.prepareTransition(
        this.drawer,
        function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this)
      );

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false");
            this.activeSource.focus();
          }
        }.bind(this),
        500
      );

      this.isOpen = false;

      trisara.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: "drawer_focus",
      });

      this.unbindEvents();
    },

    bindEvents: function () {
      // Clicking out of drawer closes it
      window.on(
        "click" + this.config.namespace,
        function (evt) {
          this.close(evt);
          return;
        }.bind(this)
      );

      // Pressing escape closes drawer
      window.on(
        "keyup" + this.config.namespace,
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      trisara.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    },

    unbindEvents: function () {
      window.off("click" + this.config.namespace);
      window.off("keyup" + this.config.namespace);

      trisara.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    },
  });

  return Drawers;
})();

/*============================================================================
  HotSpots
==============================================================================*/

class HotSpots extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.buttons = this.querySelectorAll("[data-button]");
    this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]");
    this.blockContainer = this.querySelector("[data-block-container]");

    this._bindEvents();
  }

  _removeActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    this.querySelector(`.grid-product__color-image--${id}`).classList.remove(
      "is-active"
    );
  }

  /* Setup event listeners */
  _bindEvents() {
    this.buttons.forEach((button) => {
      const id = button.dataset.button;

      button.addEventListener("click", (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        this._showContent(id);
      });
    });

    // Display active hotspot block on theme editor select
    document.addEventListener("shopify:block:select", (e) => {
      const blockId = e.detail.blockId;
      this._showContent(`${blockId}`);
    });
  }

  /* Toggle sidebar content */
  _showContent(id) {
    // Hide all hotspotBlock
    // Show the hotspotBlock with the id
    this.hotspotBlocks.forEach((block) => {
      if (block.dataset.hotspotBlock === id) {
        block.classList.add("is-active");
      } else {
        block.classList.remove("is-active");
      }
    });
  }
}

customElements.define("hot-spots", HotSpots);

function alterLength() {
  let element = document.querySelector(".toggleLength");

  if (!element) return;

  element.addEventListener("click", function () {
    if (this.querySelector("input").checked) {
      this.parentElement.classList.add("active");
    } else {
      this.parentElement.classList.remove("active");
    }
  });
}

function showMenuOnHover() {
  let items = document.querySelectorAll(
    ".header__inline-menu summary.header__menu-item "
  );

  if (!items) return;

  items.forEach((item) => {
    let hasMouseOverOccurred = false;
    let parentDetails = item.parentElement;
    item.addEventListener("mouseover", function () {
      if (!hasMouseOverOccurred) {
        this.parentElement.setAttribute("open", "");
      }
    });

    parentDetails.addEventListener("mouseleave", function () {
      hasMouseOverOccurred = false;
      this.removeAttribute("open");
    });
  });
}

function shouldShowReminder() {
  const lastShownTimestamp = localStorage.getItem('lastShownTimestamp');

  if (!lastShownTimestamp) {
    return true;
  }

  const lastShownDate = new Date(Number(lastShownTimestamp));
  const now = new Date();
  
  return now - lastShownDate >= 8 * 60 * 60 * 1000;
}

function newsletterPopup() {
  let instance = new trisara.Modals('Newsletter-Popup');

  let marketing = JSON.parse(document.getElementById(instance.id).dataset.marketing);

  if(!instance && !marketing) return;
  
  if(shouldShowReminder()) {
    localStorage.setItem('lastShownTimestamp', Date.now().toString());
  } else {
    return;
  }
  
  setTimeout(() => {
    instance.open();
  },5000);
}


function copyDiscountCodes() {
  let discountContainer = document.getElementById('present__offers')
  if(!discountContainer) return;
  let codes = discountContainer.querySelectorAll('.copy-code');

  codes.forEach(code => {
    code.addEventListener('click', function () {
      let codeWrapper = this.closest('.offer');
      let codeInput = codeWrapper.dataset.offer;
      console.log(codeInput)
      copyInputValue(codeInput);
      this.innerText = 'Copied'
    });
  });
}

function copyInputValue(input) {
  navigator.clipboard.writeText(input).then(() => {
  }, (err) => {
    console.error('Unable to copy:', err);
  });
}


function copyCodes() {
  let discountContainer = document.getElementById("currentOffers");

  if (!discountContainer) return;

  let codes = discountContainer.querySelectorAll(".discount_code-copyBtn");

  codes.forEach((code) => {
    code.addEventListener("click", function () {
      let codeWrapper = this.closest(".offer-item");
      let codeInput = codeWrapper.querySelector(".discount_code-copy");
      copyValue(codeInput);
      this.innerText = "Copied";
    });
  });
}

function copyValue(input) {
  const range = document.createRange();
  range.selectNode(input);

  const selection = document.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand("copy");
  selection.removeAllRanges();
}

function handleCollectionTabs(section) {
  const buttons = section.querySelectorAll(".collection-tabs button");
  const tabSection = section.querySelector(".collection-tab-section");

  if (!buttons.length || !tabSection) return;

  buttons.forEach(button => {
    button.addEventListener("click", function () {

      buttons.forEach(btn => btn.classList.remove("active"));

      this.classList.add("active");

      const targetId = this.getAttribute("data-id");
      if (!targetId) return;

      const allTabs = tabSection.querySelectorAll("slider-component");
      allTabs.forEach(tab => tab.classList.remove("is-selected"));

      const activeTab = tabSection.querySelector(`#tab-${targetId}`);
      if (activeTab) {
        activeTab.classList.add("is-selected");
      }
    });
  });
}

function initSpotlightCollection() {
  const sections = document.querySelectorAll(".spotlight-collection");

  sections.forEach(section => {
    const buttons = section.querySelectorAll(".spotlight-collection__names button");
    const images = section.querySelectorAll(".spotlight-collection__image .image__hero__frame");

    function resetAll() {
      buttons.forEach(b => b.classList.remove("active"));
      images.forEach(img => img.classList.remove("is-selected"));
    }

    function switchCollection(id, btn) {
      const isAlreadyActive = btn.classList.contains("active");
      resetAll();
      if (isAlreadyActive) return;

      btn.classList.add("active");

      images.forEach(img => {
        if (img.id === id) {
          img.classList.add("is-selected");
        }
      });
    }

    buttons.forEach(btn => {
      const id = btn.getAttribute("data-id");

      btn.addEventListener("click", () => {
        if (window.innerWidth <= 768) {
          switchCollection(id, btn);
        }
      });

      btn.addEventListener("mouseenter", () => {
        if (window.innerWidth > 768) {
          resetAll();
          btn.classList.add("active");

          images.forEach(img => {
            if (img.id === id) {
              img.classList.add("is-selected");
            }
          });
        }
      });
    });

    if (buttons.length) {
      switchCollection(buttons[0].getAttribute("data-id"), buttons[0]);
    }
  });
}

class TestimonialSlider {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll('.testimonial-slide');
    this.prevBtn = section.querySelector('.prev');
    this.nextBtn = section.querySelector('.next');

    if (this.slides.length <= 1) return;

    this.current = 0;
    this.interval = null;

    this.init();

    this.stopAutoplay();
  }

  init() {
    this.bindEvents();
    this.startAutoplay();
  }

  bindEvents() {
    this.nextBtn?.addEventListener('click', () => {
      this.next();
      this.restartAutoplay();
    });

    this.prevBtn?.addEventListener('click', () => {
      this.prev();
      this.restartAutoplay();
    });

    this.section.addEventListener('mouseenter', () => {
      this.stopAutoplay();
    });

    this.section.addEventListener('mouseleave', () => {
      this.startAutoplay();
    });
  }

  show(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
  }

  next() {
    this.current = (this.current + 1) % this.slides.length;
    this.show(this.current);
  }

  prev() {
    this.current =
      (this.current - 1 + this.slides.length) % this.slides.length;
    this.show(this.current);
  }

  startAutoplay() {
    this.interval = setInterval(() => {
      this.next();
    }, 5000);
  }

  stopAutoplay() {
    clearInterval(this.interval);
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".featured-collection-section").forEach(section => {
    handleCollectionTabs(section);
  });

  copyDiscountCodes();
  if (window.innerWidth > 1024) {
    showMenuOnHover();
  }
  alterLength();

  //newsletterPopup();
  copyCodes();

  initSpotlightCollection();

  const sections = document.querySelectorAll('.customer-testimonials-section');

  if (sections.length) {
    sections.forEach((section) => {
      new TestimonialSlider(section);
    });
  }
});

// var themeRellax = function(e) {
//     "use strict";
//     var t = function(e, o) {
//         var n = Object.create(t.prototype)
//           , r = 0
//           , i = 0
//           , a = 0
//           , s = 0
//           , l = []
//           , d = !0
//           , p = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(e) {
//             return setTimeout(e, 1e3 / 60)
//         }
//           , c = null
//           , u = !1;
//         try {
//             var m = Object.defineProperty({}, "passive", {
//                 get: function() {
//                     u = !0
//                 }
//             });
//             window.addEventListener("testPassive", null, m),
//             window.removeEventListener("testPassive", null, m)
//         } catch (e) {}
//         var w = window.cancelAnimationFrame || window.mozCancelAnimationFrame || clearTimeout
//           , f = window.transformProp || function() {
//             var e = document.createElement("div");
//             if (null === e.style.transform) {
//                 var t = ["Webkit", "Moz", "ms"];
//                 for (var o in t)
//                     if (void 0 !== e.style[t[o] + "Transform"])
//                         return t[o] + "Transform"
//             }
//             return "transform"
//         }();
//         n.options = {
//             speed: -2,
//             center: !1,
//             wrapper: null,
//             relativeToWrapper: !1,
//             round: !0,
//             vertical: !0,
//             frame: null,
//             horizontal: !1,
//             callback: function() {}
//         },
//         o && Object.keys(o).forEach((function(e) {
//             n.options[e] = o[e]
//         }
//         )),
//         e || (e = ".rellax");
//         var v = "string" == typeof e ? document.querySelectorAll(e) : [e];
//         if (v.length > 0) {
//             if (n.elems = v,
//             n.options.wrapper && !n.options.wrapper.nodeType) {
//                 var h = document.querySelector(n.options.wrapper);
//                 if (!h)
//                     return void console.warn("Rellax: The wrapper you're trying to use doesn't exist.");
//                 n.options.wrapper = h
//             }
//             if (n.options.frame && !n.options.frame.nodeType) {
//                 var g = document.querySelector(n.options.frame);
//                 if (!g)
//                     return void console.warn("Rellax: The frame you're trying to use doesn't exist.");
//                 n.options.frame = g
//             }
//             var y = function() {
//                 let e = [];
//                 for (var t = 0; t < n.elems.length; t++) {
//                     let o = n.elems[t]
//                       , r = {};
//                     r.el = o,
//                     r.dataPercentage = o.getAttribute("data-rellax-percentage"),
//                     r.dataSpeed = o.getAttribute("data-rellax-speed"),
//                     r.dataZindex = o.getAttribute("data-rellax-zindex") || 0,
//                     r.dataMin = o.getAttribute("data-rellax-min"),
//                     r.dataMax = o.getAttribute("data-rellax-max"),
//                     r.style = o.style.cssText,
//                     r.bounds = o.getBoundingClientRect(),
//                     r.blockHeight = o.clientHeight || o.offsetHeight || o.scrollHeight,
//                     r.blockWidth = o.clientWidth || o.offsetWidth || o.scrollWidth,
//                     e.push(r)
//                 }
//                 for (t = 0; t < e.length; t++) {
//                     let b = e[t];
//                     var o = n.options.wrapper ? n.options.wrapper.scrollTop : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
//                     if (n.options.relativeToWrapper)
//                         o = (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) - n.options.wrapper.offsetTop;
//                     var r = n.options.vertical && (b.dataPercentage || n.options.center) ? o : 0
//                       , a = n.options.horizontal && (b.dataPercentage || n.options.center) ? n.options.wrapper ? n.options.wrapper.scrollLeft : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft : 0
//                       , d = r + b.bounds.top
//                       , p = a + b.bounds.left
//                       , c = b.dataPercentage ? b.dataPercentage : (r - d + i) / (b.blockHeight + i)
//                       , u = b.dataPercentage ? b.dataPercentage : (a - p + s) / (b.blockWidth + s);
//                     n.options.center && (u = .5,
//                     c = .5);
//                     var m = b.dataSpeed ? b.dataSpeed : n.options.speed
//                       , w = z(u, c, m)
//                       , f = ""
//                       , v = b.style
//                       , h = /transform\s*:/i.exec(v);
//                     if (h) {
//                         var g = h.index
//                           , y = v.slice(g)
//                           , x = y.indexOf(";");
//                         f = x ? " " + y.slice(11, x).replace(/\s/g, "") : " " + y.slice(11).replace(/\s/g, "")
//                     }
//                     l[t] = {
//                         baseX: w.x,
//                         baseY: w.y,
//                         top: d,
//                         left: p,
//                         height: b.blockHeight,
//                         width: b.blockWidth,
//                         speed: m,
//                         style: b.style,
//                         transform: f,
//                         zindex: b.dataZindex,
//                         min: b.dataMin,
//                         max: b.dataMax
//                     }
//                 }
//             }
//               , x = function(e, t) {
//                 let o;
//                 return function() {
//                     clearTimeout(o),
//                     o = setTimeout(e, t)
//                 }
//             }(b = function() {
//                 for (var e = 0; e < l.length; e++)
//                     n.elems[e].style.cssText = l[e] && l[e].style;
//                 l = [],
//                 i = window.innerHeight,
//                 s = window.innerWidth,
//                 T();
//                 var t = function() {
//                     y(),
//                     A(),
//                     d && (window.addEventListener("resize", x),
//                     d = !1,
//                     L())
//                 };
//                 "requestIdleCallback"in window ? window.requestIdleCallback(t) : requestAnimationFrame(t)
//             }
//             , 150)
//               , b = function() {
//                 for (var e = 0; e < l.length; e++)
//                     n.elems[e].style.cssText = l[e].style;
//                 l = [],
//                 i = window.innerHeight,
//                 s = window.innerWidth,
//                 T(),
//                 y(),
//                 A(),
//                 d && (window.addEventListener("resize", b),
//                 d = !1,
//                 L())
//             }
//               , T = function() {
//                 var e = r
//                   , t = a;
//                 if (r = n.options.wrapper ? n.options.wrapper.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset,
//                 a = n.options.wrapper ? n.options.wrapper.scrollLeft : (document.documentElement || document.body.parentNode || document.body).scrollLeft || window.pageXOffset,
//                 n.options.relativeToWrapper) {
//                     var o = (document.documentElement || document.body.parentNode || document.body).scrollTop || window.pageYOffset;
//                     r = o - n.options.wrapper.offsetTop
//                 }
//                 return !(e == r || !n.options.vertical) || !(t == a || !n.options.horizontal)
//             }
//               , z = function(e, t, o) {
//                 var r = {}
//                   , i = o * (100 * (1 - e))
//                   , a = o * (100 * (1 - t));
//                 return r.x = n.options.round ? Math.round(i) : Math.round(100 * i) / 100,
//                 r.y = n.options.round ? Math.round(a) : Math.round(100 * a) / 100,
//                 r
//             }
//               , E = function() {
//                 window.removeEventListener("resize", E),
//                 window.removeEventListener("orientationchange", E),
//                 (n.options.wrapper ? n.options.wrapper : window).removeEventListener("scroll", E),
//                 (n.options.wrapper ? n.options.wrapper : document).removeEventListener("touchmove", E),
//                 c = p(L)
//             }
//               , L = function() {
//                 T() && !1 === d ? (A(),
//                 c = p(L)) : (c = null,
//                 window.addEventListener("resize", E),
//                 window.addEventListener("orientationchange", E),
//                 (n.options.wrapper ? n.options.wrapper : window).addEventListener("scroll", E, !!u && {
//                     passive: !0
//                 }),
//                 (n.options.wrapper ? n.options.wrapper : document).addEventListener("touchmove", E, !!u && {
//                     passive: !0
//                 }))
//             }
//               , A = function() {
//                 for (var e = new Array(n.elems.length), t = 0; t < n.elems.length; t++) {
//                     var o = (r - l[t].top + i) / (l[t].height + i)
//                       , d = (a - l[t].left + s) / (l[t].width + s)
//                       , p = z(d, o, l[t].speed)
//                       , c = p.y - l[t].baseY
//                       , u = p.x - l[t].baseX;
//                     null !== l[t].min && (n.options.vertical && !n.options.horizontal && (c = c <= l[t].min ? l[t].min : c),
//                     n.options.horizontal && !n.options.vertical && (u = u <= l[t].min ? l[t].min : u)),
//                     null !== l[t].max && (n.options.vertical && !n.options.horizontal && (c = c >= l[t].max ? l[t].max : c),
//                     n.options.horizontal && !n.options.vertical && (u = u >= l[t].max ? l[t].max : u)),
//                     e[t] = {
//                         positionX: u,
//                         positionY: c,
//                         zindex: l[t].zindex,
//                         i: t
//                     }
//                 }
//                 for (t = 0; t < n.elems.length; t++) {
//                     var m = e[t]
//                       , w = "translate3d(" + (n.options.horizontal ? m.positionX : "0") + "px," + (n.options.vertical ? m.positionY : "0") + "px," + m.zindex + "px) " + l[m.i].transform;
//                     n.elems[m.i].style[f] = w
//                 }
//                 n.options.callback(e)
//             };
//             return n.destroy = function() {
//                 for (var e = 0; e < n.elems.length; e++)
//                     n.elems[e].style.cssText = l[e] && l[e].style;
//                 d || (window.removeEventListener("resize", x),
//                 d = !0),
//                 w(c),
//                 c = null
//             }
//             ,
//             n.refresh = b,
//             b(),
//             n
//         }
//         console.warn("Rellax: The elements you're trying to select don't exist.")
//     };
//     return e.Rellax = t,
//     Object.defineProperty(e, "__esModule", {
//         value: !0
//     }),
//     e
// }({});

// window.addEventListener("resize", trisara.utils.debounce(50, (function() {
//     const t = window.visualViewport ? window.visualViewport.scale : 1;
//     Math.abs(t - m) > .05 ? m = t : (m = t,
//     function() {
//         const t = v();
//         window.theme.isMobile !== t && (trisara.config.bpSmall = t);
//         const e = p()
//           , s = g();
//         window.theme.windowWidth !== e && (document.dispatchEvent(new CustomEvent("theme:resize:width",{
//             bubbles: !0
//         })),
//         window.theme.windowWidth = e),
//         window.theme.windowHeight !== s && (document.dispatchEvent(new CustomEvent("theme:resize:height",{
//             bubbles: !0
//         })),
//         window.theme.windowHeight = s),
//         document.dispatchEvent(new CustomEvent("theme:resize",{
//             bubbles: !0
//         }))
//     }())
// })));

// if (!customElements.get('parallax-hero')) {
//   customElements.define(
//     'parallax-hero',
//     class ParallaxHero extends HTMLElement {
//       defaultOptions = {
//         center: true,
//         round: true,
//         frame: this,
//       };

//       constructor() {
//         super();

//         this.rellax = null;
//         this.refreshEvent = trisara.utils.debounce(500, () => {
//           this.refresh();
//         });
//       }

//       connectedCallback() {
//         const imageSelector = this.querySelector('[data-parallax-img]');
//         if (!imageSelector) return;

//         const speed = this.getAttribute('data-parallax-speed') || -2;
//         const options = {
//           ...this.defaultOptions,
//           speed: parseFloat(speed),
//         };

//         const Rellax = window.themeRellax?.Rellax || window.Rellax;
//         this.rellax = new Rellax(imageSelector, options);

//         document.addEventListener('theme:resize', this.refreshEvent);

//         const onLoad = () => requestAnimationFrame(() => this.refresh());
//         document.readyState === 'complete' ? onLoad() : window.addEventListener('load', onLoad, {once: true});
//       }

//       refresh() {
//         this.rellax?.refresh();
//       }

//       disconnectedCallback() {
//         this.rellax?.destroy();
//         document.removeEventListener('theme:resize', this.refreshEvent);
//       }
//     }
//   );
// }

